<!-- Thanks: https://markus.oberlehner.net/blog/transition-to-height-auto-with-vue/ -->

<script lang="ts">
import { Transition } from 'vue'

export default defineComponent({
  name: 'TransitionExpand',
  setup(_, { slots }) {
    // 브라우저 강제 layout recalc — getComputedStyle 은 resolved value 를 반환해야 하므로
    // 프로퍼티 접근이 pending style/layout 계산을 flush. 반환 타입 `void` 로 호출자가 반환값에 의존 못 하게 차단.
    const forceRepaint = (el: HTMLElement): void => getComputedStyle(el).height

    const onEnter = (element: HTMLElement) => {
      const width = getComputedStyle(element).width

      element.style.width = width
      element.style.position = 'absolute'
      element.style.visibility = 'hidden'
      element.style.height = 'auto'

      const height = getComputedStyle(element).height

      element.style.width = ''
      element.style.position = ''
      element.style.visibility = ''
      element.style.height = '0px'

      forceRepaint(element)

      // Trigger the animation.
      // We use `requestAnimationFrame` because we need
      // to make sure the browser has finished
      // painting after setting the `height`
      // to `0` in the line above.
      requestAnimationFrame(() => {
        element.style.height = height
      })
    }

    const onAfterEnter = (element: HTMLElement) => {
      element.style.height = 'auto'
    }

    const onLeave = (element: HTMLElement) => {
      const height = getComputedStyle(element).height

      element.style.height = height

      forceRepaint(element)

      requestAnimationFrame(() => {
        element.style.height = '0px'
      })
    }

    return () => h(
      h(Transition),
      {
        name: 'expand',
        onEnter,
        onAfterEnter,
        onLeave,
      },
      () => slots.default?.(),
    )
  },
})
</script>

<style>
.expand-enter-active,
.expand-leave-active {
  overflow: hidden;
  transition: block-size var(--expand-transition-duration, 0.25s) ease;
}

.expand-enter-from,
.expand-leave-to {
  block-size: 0;
}
</style>

<style scoped>
* {
  backface-visibility: hidden;
  perspective: 1000px;
  transform: translateZ(0);
  will-change: block-size;
}
</style>
